/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsBubbleMessageAdd: {
  name: 'bubble-message-add';
  data: string;
} = {
  name: 'bubble-message-add',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M2 5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H8.277l-4.762 2.858A1 1 0 0 1 2 21V5Zm18 0H4v14.234l3.248-1.949A2 2 0 0 1 8.277 17H20V5Zm-8 3a1 1 0 0 1 1 1v1h1a1 1 0 1 1 0 2h-1v1a1 1 0 1 1-2 0v-1h-1a1 1 0 1 1 0-2h1V9a1 1 0 0 1 1-1Z" fill="currentColor"/></svg>`,
};
